// Wrapper de QZ Tray para imprimir ESC/POS raw en ticketeras termicas.
// QZ Tray es una app local (https://qz.io) que expone el puerto USB/LAN de la
// impresora al navegador a traves de un websocket en localhost:8181.

let qzPromise = null;

function loadQz() {
  if (qzPromise) return qzPromise;
  qzPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('sin entorno de navegador'));
      return;
    }
    if (window.qz) {
      resolve(window.qz);
      return;
    }
    const sources = [
      'http://localhost:8181/qz-tray.js',
      'https://cdn.jsdelivr.net/npm/qz-tray@2.2.3/qz-tray.js',
    ];
    let i = 0;
    const tryNext = () => {
      if (i >= sources.length) {
        reject(new Error('qz-tray.js no disponible'));
        return;
      }
      const s = document.createElement('script');
      s.src = sources[i++];
      s.onload = () => (window.qz ? resolve(window.qz) : tryNext());
      s.onerror = () => tryNext();
      document.head.appendChild(s);
    };
    tryNext();
  });
  return qzPromise;
}

// Filtra impresoras virtuales (PDF, fax, XPS, etc.) que no son fisicas.
const VIRTUAL = /pdf|dopdf|fax|onenote|xps|document writer|microsoft print|save to/i;
// Busca una ticketera termica por nombre.
const THERMAL = /roccia|thermal|receipt|ticketera|pos|rc[- ]?8002|80mm|80 mm/i;

async function ensureConnected(qz) {
  if (!qz.websocket.isActive()) {
    await qz.websocket.connect();
  }
}

// Devuelve true si QZ Tray esta instalado y alcanzable.
export async function qzAvailable() {
  try {
    await loadQz();
    return true;
  } catch {
    return false;
  }
}

// Lista los nombres de impresoras fisicas detectadas por QZ Tray.
export async function qzListPrinters() {
  const qz = await loadQz();
  await ensureConnected(qz);
  const all = (await qz.printers.find()) || [];
  return all.filter((n) => !VIRTUAL.test(n));
}

// Elige la ticketera: preferencia guardada > coincidencia termica > primera fisica.
export async function qzPickPrinter(preferredName) {
  const printers = await qzListPrinters();
  if (!printers.length) return null;
  if (preferredName && printers.some((n) => n.toLowerCase() === preferredName.toLowerCase())) {
    return preferredName;
  }
  return printers.find((n) => THERMAL.test(n)) || printers[0];
}

// Envia bytes ESC/POS raw a la impresora indicada.
export async function qzPrintRaw(printerName, bytes) {
  const qz = await loadQz();
  await ensureConnected(qz);
  const config = qz.configs.create(printerName, { rasterize: 'none' });
  const data = [{ type: 'raw', format: 'command', data: Array.from(bytes) }];
  await qz.print(config, data);
}
